import * as msal from "@azure/msal-browser";
import type { Store } from "vuex";
import type { State } from "@/store/state";
import { dispatchLogInSSO, dispatchLogInSSOFailed } from "@/store/main/actions";
import { readMsalConfig } from "@/store/main/getters";
// import {
//   commitSetSSOLoggedIn,
//   commitSetLoggedIn,
// } from "@/store/main/mutations";

let instance: msal.PublicClientApplication | null = null;
let initPromise: Promise<msal.PublicClientApplication> | null = null;

export async function initMsalAndHandleRedirect(store: Store<State>) {
  const cfg = readMsalConfig(store);

  if (!cfg?.clientId || !cfg?.authority) {
    console.log("MSAL config missing from store (clientId/authority)");
    // throw new Error("MSAL config missing from store (clientId/authority)");
  }

  const msal_client = await getMsalInstance(cfg);

  try {
    const resp = await msal_client.handleRedirectPromise();

    // const accounts = msal_client.getAllAccounts();
    // const isLoggedIn = accounts.length > 0;
    // console.log("msal recognises a logged in user and setting ssologgedin and loggedin to:");
    // console.log(isLoggedIn)
    // commitSetSSOLoggedIn(store, isLoggedIn);
    // commitSetLoggedIn(store, isLoggedIn);

    if (resp !== null) {
      // Equivalent to: .then(this.handleResponse)
      await dispatchLogInSSO(store, resp);
      // console.log("msal dispatchloginsso successful");
    } else {
      // console.log("resp was falsey");
    }
  } catch (err: any) {
    console.log(err);
    await dispatchLogInSSOFailed(store, err);
    // Re-throw if you want startup to fail hard:
    // throw err;
  }

  return msal_client;
}

export async function getMsalInstance(msalConfig: {
  clientId: string;
  authority: string;
}) {
  if (instance) {
    // console.log("msal client already exists, not creating a new one");
    return instance;
  }

  if (!initPromise) {
    initPromise = (async () => {
      const msal_client = new msal.PublicClientApplication({
        auth: {
          clientId: msalConfig.clientId,
          authority: msalConfig.authority,
          redirectUri: window.location.origin + "/login",
        },
      });
      // console.log("created new msal client");
      await msal_client.initialize();
      //   await msal_client.handleRedirectPromise().then(handleResponse);; // safe even if no redirect happened
      instance = msal_client;
      // console.log("initialised new msal client");
      return msal_client;
    })();
  }

  return initPromise;
}
